import React from "react";

export default (props) => {
    if (props.type && props.type.placeHolder) {
        return <props.type.placeHolder {...props} />;
    }
    return (
        <div className="ph-item ph-table">
            <div className="ph-col-12">
                <div className="ph-row ph-head">
                    {[0, 0].map((i, idx) => <div key={idx} className="ph-col-2 ph-cell"/>)}
                </div>
                <div className="ph-row ph-head">
                    {[0, 0, 0, 0, 0, 0].map((i, idx) => <div key={idx} className="ph-col-2 ph-cell"/>)}
                </div>
                {[0, 0, 0].map((i, idx) => <div key={idx} className="ph-row">
                    {[0, 0, 0, 0, 0, 0].map((i, idx) => <div key={idx} className="ph-col-2 ph-cell"/>)}
                </div>)}
                <div className="ph-row ph-foot">
                    <div className="ph-col-12 ph-cell"/>
                </div>
            </div>
        </div>
    );
};